import React, { Component } from "react";
import Select from "react-select";
import { isMobile } from "react-device-detect";

const customStyles = {
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    width: "100%",
    borderWidth: "0px",
    borderBottomWidth: "0px",
    borderRadius: "0px"
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
};

class SelectDropdown extends Component {
  state = {
    searchVal: ""
  };
  render() {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px",
          borderBottom: "0px",
          borderBottomColor: "#cccccc",
          borderStyle: "solid",
          paddingBottom: isMobile ? "0px" : "2px"
        }}
      >
        <div
          className="col-sm-4 align-self-center”"
          style={{
            margin: "0px",
            verticalAlign: "middle",
            height: "auto",
            padding: "0px"
          }}
        >
          <div
            style={{
              marginTop: isMobile ? "13px" : "0px",
              verticalAlign: "middle",
              lineHeight: isMobile ? "20px" : "37px",
              padding: "0px",
              color: isMobile ? "grey" : "black",
              marginBottom: isMobile ? "-1px" : "0px"
            }}
          >
            {this.props.title}
          </div>
        </div>
        <div
          className="col-sm-8"
          style={{
            display: "block",
            padding: "1px",
            textAlign: "left",
            border: "1px solid gainsboro",
            borderRadius: "5px",
            backgroundColor: "white"
          }}
        >
          <Select
            isClearable
            onChange={this.handleChange}
            options={this.getOptions()}
            label={this.props.label}
            placeholder={this.props.placeholder}
            value={this.getValue()}
            styles={customStyles}
            defaultValue={""}
            theme={theme => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary: "blue"
              },
              borderBottomWidth: "0px",
              borderBottomColor: "blue"
            })}
            isDisabled={this.props.disabled}
          />
        </div>
      </div>
    );
  }

  handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === "clear") {
      this.props.stateHandler(
        "",
        this.props.stateFieldName,
        this.props.isPayload
      );
    } else {
      if (newValue && newValue !== undefined) {
        this.props.stateHandler(
          newValue.value,
          this.props.stateFieldName,
          this.props.isPayload
        );
        if (this.props.otherFields && this.props.otherFields.length > 0) {
          this.props.otherFields.map(item => {
            //console.log("auto update: " + JSON.stringify(item));
            let srcVal = newValue.fullRec[item.src];
            if (srcVal === undefined) {
              srcVal = "";
            }
            this.props.stateHandler(srcVal, item.tgt, this.props.isPayload);
          });
        }
      }
    }
  };

  getOptions = () => {
    let newArray = [];
    if (!this.props.data && this.props.data === undefined) {
      //console.log("Data is undefined for SelectDropdown");
      return [];
    }

    //console.log("No of drop down records: " + this.props.data.length);
    for (let i = 0; i < this.props.data.length; i++) {
      let item = this.props.data[i];
      let filter = {};
      if (
        this.props.filter &&
        this.props.filter !== undefined &&
        this.props.filter.length > 0
      ) {
        filter = this.props.filter[0];
      }
      if (filter.src && this.props.stateRcvd && this.props.stateRcvd.payload) {
        if (item[filter.src] === this.props.stateRcvd.payload[filter.tgt]) {
          newArray.push({
            value: item[this.props.fieldName],
            label: item[this.props.fieldName],
            fullRec: item
          });
        }
      } else {
        newArray.push({
          value: item[this.props.fieldName],
          label: item[this.props.fieldName],
          fullRec: item
        });
      }
    }

    return newArray;
  };

  getValue = () => {
    return { value: this.props.value, label: this.props.value };
  };
}

export default SelectDropdown;



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/SelectDropdown/SelectDropdown.jsx